module.exports = "mutation ($data: PostInput!) {\n  PostCreate(data: $data) {\n    id\n  }\n}\n"